const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_16_",
    transform: "matrix(0.0451419,0,0,0.0454718,0.499983,0.423259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.591,423.714C275.755,424.67 271.844,425.519 267.962,426.234C257.814,428.121 251.105,437.881 252.982,448.038C253.909,453.035 256.747,457.197 260.6,459.914C264.571,462.709 269.625,463.971 274.775,463.013C279.398,462.155 284.057,461.146 288.629,460.005C298.65,457.511 304.755,447.359 302.255,437.343C299.761,427.318 289.618,421.218 279.591,423.714Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.887,173.047C419.197,176.995 421.698,180.218 424.857,182.445C429.541,185.744 435.67,186.854 441.519,184.92C451.325,181.664 456.638,171.09 453.394,161.289C451.916,156.821 450.276,152.339 448.529,147.975C444.693,138.385 433.815,133.716 424.22,137.552C414.635,141.386 409.964,152.267 413.803,161.86C415.271,165.528 416.646,169.293 417.887,173.047Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,397.013C337.061,399.191 333.656,401.299 330.226,403.274C321.277,408.436 318.212,419.875 323.372,428.82C324.773,431.253 326.639,433.242 328.788,434.762C334.557,438.821 342.392,439.429 348.915,435.671C352.993,433.319 357.048,430.817 360.977,428.219C369.591,422.528 371.962,410.925 366.268,402.307C360.575,393.686 348.977,391.318 340.36,397.013Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.022,225.279C464.615,214.957 455.921,206.923 445.596,207.326C435.284,207.733 427.244,216.43 427.649,226.748C427.804,230.693 427.844,234.697 427.753,238.638C427.608,245.111 430.774,250.881 435.694,254.349C438.625,256.413 442.182,257.662 446.039,257.75C456.361,257.979 464.915,249.792 465.144,239.465C465.247,234.756 465.208,229.985 465.022,225.279Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.835,347.816C406.558,341.606 394.848,343.292 388.649,351.554C386.275,354.718 383.775,357.843 381.215,360.852C374.525,368.712 375.47,380.518 383.33,387.213C383.778,387.593 384.231,387.942 384.701,388.27C392.515,393.779 403.375,392.513 409.693,385.099C412.75,381.509 415.73,377.776 418.567,373.997C424.767,365.735 423.089,354.017 414.835,347.816Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.325,280.213C432.47,277.123 421.975,282.609 418.887,292.464C417.705,296.229 416.395,300.012 414.981,303.717C411.876,311.873 414.851,320.847 421.671,325.656C422.922,326.535 424.3,327.28 425.797,327.846C435.446,331.528 446.251,326.687 449.929,317.034C451.608,312.629 453.166,308.128 454.575,303.652C457.66,293.795 452.178,283.303 442.325,280.213Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.999,426.402C181.279,423.4 165.24,418.288 150.031,411.158C149.851,411.064 149.69,410.957 149.501,410.871C145.917,409.184 142.339,407.377 138.871,405.489C138.859,405.475 138.837,405.466 138.818,405.458C132.455,401.954 126.245,398.077 120.212,393.83C32.24,331.86 11.088,209.872 73.062,121.901C86.538,102.779 102.846,86.826 121.027,74.182C121.251,74.026 121.475,73.871 121.697,73.714C185.764,29.57 272.757,26.595 340.786,71.957L326.175,93.068C322.113,98.944 324.612,103.226 331.723,102.586L395.19,96.904C402.31,96.264 406.568,90.105 404.653,83.229L387.61,21.823C385.702,14.939 380.817,14.115 376.751,19.99L362.106,41.151C312.182,7.638 252.303,-5.141 192.87,5.165C186.884,6.201 180.982,7.469 175.161,8.945C175.116,8.953 175.08,8.958 175.044,8.966C174.819,9.021 174.591,9.094 174.372,9.155C123.122,22.316 78.407,52.207 46.5,94.855C46.231,95.174 45.954,95.486 45.7,95.833C44.639,97.262 43.586,98.724 42.555,100.186C40.869,102.582 39.207,105.038 37.617,107.494C37.418,107.79 37.266,108.091 37.092,108.39C10.762,149.191 -1.938,196.361 0.24,244.383C0.245,244.541 0.236,244.7 0.24,244.862C0.451,249.553 0.823,254.309 1.328,258.991C1.355,259.293 1.422,259.579 1.473,259.881C1.995,264.589 2.65,269.308 3.471,274.026C11.815,322.164 34.523,365.481 68.55,399.186C68.629,399.265 68.711,399.351 68.791,399.433C68.819,399.464 68.85,399.48 68.877,399.509C78.019,408.526 87.963,416.866 98.67,424.407C126.69,444.151 157.891,457.202 191.399,463.215C201.566,465.042 211.278,458.274 213.102,448.112C214.925,437.943 208.163,428.223 197.999,426.402Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.124,83.198C212.761,83.198 205.987,89.978 205.987,98.329L205.987,249.076L343.857,320.347C346.076,321.496 348.452,322.037 350.79,322.037C356.266,322.037 361.555,319.055 364.244,313.852C368.079,306.426 365.177,297.303 357.751,293.468L236.244,230.65L236.244,98.329C236.243,89.978 229.477,83.198 221.124,83.198Z",
    style: {
      fill: "black",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryBlack);
export default __webpack_public_path__ + "static/media/historyBlack.79b021814c98c0801266766c937f796e.svg";
export { ForwardRef as ReactComponent };